import { useLocation, useNavigate } from "react-router-dom";
import { PageContainer } from "src/components/organisms/contents";
import Toast from "src/pages/myInfo/components/InfoToast";
import { useEffect, useState } from "react";
import { useViewport } from "src/common/hooks/ViewPort";
import { shopData } from "../PointBoxPage";
import { SubConHeader } from "src/components/atoms/SubHeaderBox/SubConHeader";
import { ReactComponent as IconSadOpenWating } from "../../../styles/assets/svg/icon_sadOpenWating.svg";

export const PointBoxChangeList = () => {
  const navi = useNavigate();
  const { px } = useViewport();
  const location = useLocation() as {
    state?: {
      toast?: string;
      imgSrc?: string;
      name?: string;
      title?: string;
      price?: number;
    };
  };
  const [toast, setToast] = useState<string | null>(null);
  //   const { imgSrc, name, title, price } = location.state ?? {};

  useEffect(() => {
    if (location.state?.toast) {
      setToast(location.state.toast);
      navi(".", { replace: true, state: {} });
    }
  }, [location.state, navi]);

  return (
    <PageContainer isNavBar={false} active={null}>
      <>
        {/* 헤더 */}
        <SubConHeader
          title="교환내역"
          $bgColor="#fff"
          onClickArrow={() => navi(-1)}
        />

        <div
          style={{
            paddingBottom: "40px",
            height: "calc(100% - 56px)",
          }}
        >
          {shopData.length > 0 ? (
            shopData.map((item: any) => {
              return (
                <div
                  key={item.oid}
                  style={{
                    width: "100%",
                    maxWidth: "45rem",
                    marginTop: 16,
                    padding: 16,
                    background: "#fff",
                    borderRadius: 12,
                    outline: "1px var(--neutral-300, #D4D4D4) solid",
                    outlineOffset: "-1px",
                    position: "relative",
                  }}
                >
                  {item.isUse === true && (
                    <div
                      style={{
                        position: "absolute",
                        left: 0,
                        top: 0,
                        width: "100%",
                        height: "100%",
                        background: "#F5F5F5",
                        opacity: 0.5,
                      }}
                    />
                  )}
                  <div
                    style={{
                      width: "100%",
                      display: "flex",
                      justifyContent: "space-between", // 양 끝으로 배치
                      alignItems: "center",
                      gap: 12,
                      // cursor: "pointer",
                    }}
                    // onClick={() => navi("/point/giftDetails", { state: item })}
                  >
                    {/* 왼쪽: 이미지 + 텍스트 */}
                    <div style={{ display: "flex", gap: 12 }}>
                      <div
                        style={{
                          width: "80px",
                          height: "80px",
                          borderRadius: 8,
                          overflow: "hidden",
                        }}
                      >
                        <img
                          src={item.imgSrc}
                          alt={item.name}
                          style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                          }}
                        />
                      </div>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "center",
                        }}
                      >
                        <span
                          style={{
                            fontSize: 13,
                            fontWeight: 500,
                            lineHeight: "20px",
                            color: "#A3A3A3",
                          }}
                        >
                          {item.title}
                        </span>
                        <span
                          style={{
                            fontSize: 14,
                            fontWeight: 700,
                            lineHeight: "20px",
                            color: "#404040",
                          }}
                        >
                          {item.name}
                        </span>
                        <span
                          style={{
                            fontSize: 14,
                            fontWeight: 500,
                            lineHeight: "20px",
                            color: "#A3A3A3",
                          }}
                        >
                          {item.buyDate} 구매
                        </span>
                      </div>
                    </div>

                    {/* 오른쪽: 아이콘 */}
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      {item.isUse === true ? (
                        <span
                          style={{
                            fontSize: 14,
                            fontWeight: 500,
                            color: "#A3A3A3",
                            lineHeight: "20px",
                          }}
                        >
                          사용완료
                        </span>
                      ) : (
                        <svg
                          width="20"
                          height="20"
                          viewBox="0 0 20 20"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          {/* <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M8.22032 5.22032C8.36094 5.07987 8.55157 5.00098 8.75032 5.00098C8.94907 5.00098 9.13969 5.07987 9.28032 5.22032L13.5303 9.47032C13.6708 9.61094 13.7497 9.80157 13.7497 10.0003C13.7497 10.1991 13.6708 10.3897 13.5303 10.5303L9.28032 14.7803C9.13814 14.9128 8.9501 14.9849 8.75579 14.9815C8.56149 14.9781 8.37611 14.8994 8.2387 14.7619C8.10128 14.6245 8.02257 14.4391 8.01914 14.2448C8.01571 14.0505 8.08784 13.8625 8.22032 13.7203L11.9403 10.0003L8.22032 6.28032C8.07987 6.13969 8.00098 5.94907 8.00098 5.75032C8.00098 5.55157 8.07987 5.36094 8.22032 5.22032Z"
                          fill="#525252"
                        /> */}
                        </svg>
                      )}
                    </div>
                  </div>
                </div>
              );
            })
          ) : (
            <>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  padding: "32px 0 ",
                  gap: 8,
                  height: "100%",
                }}
              >
                <IconSadOpenWating />
                <p
                  style={{
                    fontSize: 14,
                    fontWeight: 500,
                    lineHeight: "20px",
                    color: "#a3a3a3",
                    textAlign: "center",
                  }}
                >
                  교환 내역이 없습니다.
                </p>
              </div>
            </>
          )}
        </div>

        <Toast
          message={toast ?? ""}
          open={!!toast}
          px={px}
          onClose={() => setToast(null)}
        />
      </>
    </PageContainer>
  );
};
